import * as React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Nav = () => {
    return (
            <div className='navbar'>
                <ul>
                    <li><Link to='/'>home</Link></li>
                    <li><Link to='/misc'>misc</Link></li>
                </ul>
            </div>
    );
}

export default Nav;